import { useCallback, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import { Optional } from 'packages/types'
import { useI18n } from 'builder/hooks/useI18n'
import { TextField } from 'builder/components/TextField'
import EditorField from 'builder/components/EditorField'
import { actions as editorActions } from 'builder/modules/resumeEditor'

type Props = {
  lastName: Optional<string>
}

export const LastName = (props: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { lastName } = props
  const handleSimpleFieldUpdate = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target
      dispatch(
        editorActions.updateSimpleField({
          name: 'lastName',
          value,
          debounce: true,
        }),
      )
    },
    [dispatch],
  )

  return (
    <>
      {/* Last name */}
      <EditorField>
        <TextField
          label={i18n.t('builder.resume_editor.last_name')}
          value={lastName || ''}
          name="lastName"
          onChange={handleSimpleFieldUpdate}
        />
      </EditorField>
    </>
  )
}
